import { setfontList, loadCustomizedInformation } from "@/common/design";
import { useSdkStore } from "@/stores/sdk";

export const initDesign = async () => {
    await setfontList()
    await loadCustomizedInformation()
}
